module.exports = __webpack_public_path__ + "static/media/back.4e3faa72.png";